import { render, staticRenderFns } from "./PrerequisitesPopover.vue?vue&type=template&id=76ca400d&scoped=true"
import script from "./PrerequisitesPopover.vue?vue&type=script&lang=js"
export * from "./PrerequisitesPopover.vue?vue&type=script&lang=js"
import style0 from "./PrerequisitesPopover.vue?vue&type=style&index=0&id=76ca400d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76ca400d",
  null
  
)

export default component.exports